<template>
  <vx-card>
    <vs-row vs-align="center"
            vs-type="flex"
            vs-justify="end"
            class="pb-4"
            vs-w="12">
      <vs-button @click="openUserPopup('Benutzer erstellen','Erstellen')">Benutzer erstellen</vs-button>
    </vs-row>
    <vs-table :data="admins">
      <template slot="thead">
        <vs-th>Nro</vs-th>
        <vs-th>Email</vs-th>
        <vs-th>Name</vs-th>
        <vs-th>Aktionen</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].id">
            {{indextr + 1}}
          </vs-td>
          <vs-td :data="data[indextr].email">
            {{data[indextr].email}} <span v-if="currentUser.email === data[indextr].email">(Du)</span>
          </vs-td>
          <vs-td :data="data[indextr].username">
            {{data[indextr].firstname}} {{data[indextr].lastname}}
          </vs-td>
          <vs-td :data="data[indextr].id">
            <vs-row
              vs-type="flex"
              vs-align="center"
              vs-justify="space-around"
            >
              <vs-button
                @click="openDeletePopup(data[indextr].id)"
                color="danger"
                type="filled"
                icon-pack="feather"
                icon="icon-trash"
                v-if="currentUser.email !== data[indextr].email"/>
            </vs-row>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <!--    add new user popup-->
    <vx-modal :title="popupTitle" :active.sync="showAddUserPopup" v-if="showAddUserPopup" detach>
      <vs-input
        name="firstName"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Vorname *"
        v-model="firstName"
        class="w-full"/>
      <vs-input
        name="lastName"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Nachname *"
        v-model="lastName"
        class="w-full"/>
      <vs-input
        name="email"
        icon-no-border
        icon="icon icon-mail"
        icon-pack="feather"
        label-placeholder="E-Mail *"
        v-model="email"
        type="email"
        class="w-full"/>
      <vs-input
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Passwort * (min. 7 Zeichen)"
        v-model="password"
        class="w-full"/>
      <vs-input
        name="rePassword"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Passwort wiederholen *"
        v-model="rePassword"
        class="w-full"/>
      <vs-row
        vs-type="flex"
        vs-align="center"
        vs-justify="end"
        class="pt-6">
        <vs-button @click="createAdminUser">{{buttonTitle}}</vs-button>
      </vs-row>
    </vx-modal>
    <vx-modal title="Sind Sie sicher?" :active.sync="showConfirmPopUp"  v-if="showConfirmPopUp" detach>
      <p>Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?</p>
      <vs-row vs-type="flex" vs-justify="end" class="pt-12" vs-w="12">
        <vs-button @click="onConfirmPress" color="danger" type="filled">Ja</vs-button>
      </vs-row>
    </vx-modal>
    <!--    add new user popup-->
  </vx-card>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  export default {
    data() {
      return {
        admins: [],
        // add user popup
        popupTitle: '',
        buttonTitle :'',
        showAddUserPopup: false,
        showConfirmPopUp: false,
        recordToDelete: null,
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        rePassword: '',
        currentUser: JSON.parse(localStorage.getItem('user'))
      }
    },
    methods: {
      ...mapActions(['fetchAllAdmins']),
      ...mapActions(['createAdmin']),
      ...mapActions(['deleteAdmin']),
      openUserPopup(title, buttonTitle) {
        this.popupTitle = title;
        this.buttonTitle  = buttonTitle
        this.showAddUserPopup = true;
      },
      getAllAdminUsers() {
        this.fetchAllAdmins().then(() => {
          this.admins = this.getAllAdmins
        })
      },
      createAdminUser() {
        let newAdmin = {
          firstname: this.firstName,
          lastname: this.lastName,
          email: this.email,
          password: this.password,
          password_confirmation: this.rePassword
        }
        this.createAdmin(newAdmin).then((res) => {
          if (res === true) {
            this.getAllAdminUsers()
            this.firstname = ''
            this.lastname = ''
            this.email = ''
            this.password = ''
            this.rePassword = ''
            this.firstName = ''
            this.lastName = ''
            this.showAddUserPopup = false
          }
        })
      },
      openDeletePopup(id) {
        this.showConfirmPopUp = true
        this.recordToDelete = id
      },
      onConfirmPress() {
        this.deleteAdmin(this.recordToDelete).then((res) => {
          if (res === true) {
            this.recordToDelete = null
            this.getAllAdminUsers()
            this.showConfirmPopUp = false
            this.$toast.error('Benutzer glöschet')
          }
        })
      }
    },
    mounted() {
      this.getAllAdminUsers()
    },
    computed: {
      ...mapGetters(['getAllAdmins']),
    }
  }

</script>
